// extracted by mini-css-extract-plugin
export default {"pinPreferenceInputContainer":"pin-delivery-preference-input__pin-preference-input-container__u6PwB"};